import { firestoreAction } from 'vuexfire'
import { db, arrayUnion, arrayRemove } from '@/plugins/firebase'

const state = {
    recommendations: {}
}


const actions = {
    bindRecommendations: firestoreAction(async ({bindFirestoreRef}) => {
        return await bindFirestoreRef("recommendations", db.collection("global").doc("recommendations"));
    }),
    addTags: async function({getters}, tags){
        let remainingTags = tags.filter(t => !getters.getTagSet.has(t));
        if(remainingTags.length > 0){
            await db.collection("global").doc("recommendations").update({
                tags:arrayUnion(...remainingTags)
            })
        }
    },
    removeTags: async function({rootState, getters}, tags){
        console.log(tags);
        let remainingTags = tags.filter(t => getters.getTagSet.has(t)).filter(t => !rootState.questions.myQuestions.find(q => q.tags.includes(t)));
        console.log(remainingTags);
        if(remainingTags.length > 0){
            let promises = await Promise.all(remainingTags.map(async t => await db.collection("questions").where("tags","array-contains",t).limit(1).get()))
            let remainingTags2 = promises.flatMap((snap, i) => {
                console.log(snap);
                return snap.docs.length == 0 ? [remainingTags[i]] : []
            })
            await db.collection("global").doc("recommendations").update({
                tags:arrayRemove(...remainingTags2)
            })
        }
    },
    addPseudo: async function({getters}, pseudo){
        if(!getters.getPseudoSet.has(pseudo)){
            await db.collection("global").doc("recommendations").update({
                pseudos:arrayUnion(pseudo)
            })
        }
    },
    removePseudo: async function({}, pseudo){
        await db.collection("global").doc("recommendations").update({
            pseudos:arrayRemove(pseudo)
        })
    },
}
const getters = {
    getTagSet: state => new Set(state.recommendations.tags),
    getPseudoSet: state => new Set(state.recommendations.pseudos),
    getOtherPseudos: (state, getters, rootState) => rootState.db.user ? state.recommendations.pseudos.filter(p => p!== rootState.db.user.displayName) : []
}

export default {
    state,
    actions,
    getters
}